module.exports = "https://static.im-cdn.com/mjc/storefront/Cipher/static/media/DefaultCategoryImage.73ea54d2.png";